import { Profile } from "model/profile/schema";

export const SET_AUTH = "SET_AUTH";
export const SET_PROFILE = "SET_PROFILE";

export interface AuthState {
  authenticated: boolean;
  profile?: Profile;
}

export interface SetAuthActionTypes {
  type: typeof SET_AUTH;
  authenticated: boolean;
}

export interface SetProfileActionTypes {
  type: typeof SET_PROFILE;
  profile?: Profile;
}

export type AuthActionTypes = SetAuthActionTypes | SetProfileActionTypes;
